import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { TODO } from '@b2c/types/index';
import angular from 'angular';

export const FormResponsesServiceModule = angular.module('acme.common.service.forms.responses', [
  ApiVersionFactoryModule
])
.service('FormResponsesService', ['$http', 'ApiVersionFactory', function($http, ApiVersionFactory) {

    return {

      model: [],
      oncePerCartCollection: {},

      api: {

        service: '/v1/b2c/forms/responses',

        detail: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'get',
            url: av.init({
              url: this.service + '/' + props.id,
              version: 'v2'
            }),
            headers: {
              'x-b2c-tenant-id': props.tenantId
            }
          });

        },

        create: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'post',
            url: av.init({
              url: this.service,
              version: 'v2'
            }),
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            data: {
              formId: props.formId,
              name: props.name,
              type: props.type,
              source: props.source,
              sourceFormId: props.sourceFormId,
              sourceFormResponseId: props.sourceFormResponseId,
              sourceFormUploads: props.sourceFormUploads,
              customFields: props.customFields,
              responseData: props.responseData,
              submissionDate: props.submissionDate
            }
          });
        },

        update: function(props) {
          var av = new ApiVersionFactory();

          return $http({
            method: 'put',
            url: av.init({
              url: this.service,
              version: 'v2'
            }),
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            data: {
              id: props.id,
              formId: props.formId,
              name: props.name,
              type: props.type,
              source: props.source,
              sourceFormId: props.sourceFormId,
              sourceFormResponseId: props.sourceFormResponseId,
              sourceFormUploads: props.sourceFormUploads,
              customFields: props.customFields,
              responseData: props.responseData,
              submissionDate: props.submissionDate
            }
          });
        }

      },

      init: function() {
        return true;
      },

      setResponses: function(forms) {
        this.model = forms;
      },

      getResponses: function() {
        return this.model;
      },

      addResponse: function(response) {
        var found = this.findResponseById(response.id);

        if (!found) {
          this.model.push(response);
        }
      },

      hasResponses: function() {
        return (this.model instanceof Array && this.model.length);
      },

      findResponseById: function(id) {
        var result: TODO | false = false;

        if (id) {
          for (let i = 0; i < this.model.length; i++) {
            if (this.model[i].id === id) {
              result = {
                index: i,
                form: this.model[i]
              };
              break;
            }
          }
        }

        return result;
      },
      
      hasOncePerCartResponse: function (formId) {
        return (this.oncePerCartCollection[formId]);
      },
      
      addOncePerCartResponse: function (formId, collection) {
        if(!this.hasOncePerCartResponse(formId)) {
          this.oncePerCartCollection[formId] = collection;
        }
      },
      
      getOncePerCartResponse: function (formId) {
        var r = false;
        if(this.hasOncePerCartResponse(formId)) {
          r = this.oncePerCartCollection[formId];
        }
        return r;
      }

    };

}]).name;